// Mock data para Tu Iglesia App - Centro Musical Cristiano

export const mockArtists = [
  {
    id: '1',
    name: 'Hillsong Worship',
    image: 'https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=400',
    genre: 'Worship Contemporáneo',
    followers: '2.5M'
  },
  {
    id: '2',
    name: 'Elevation Worship',
    image: 'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400',
    genre: 'Worship Contemporáneo',
    followers: '1.8M'
  },
  {
    id: '3',
    name: 'Marcos Witt',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400',
    genre: 'Alabanza Latina',
    followers: '3.2M'
  },
  {
    id: '4',
    name: 'Christine D\'Clario',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
    genre: 'Worship Latino',
    followers: '1.1M'
  },
  {
    id: '5',
    name: 'Bethel Music',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
    genre: 'Worship Profético',
    followers: '2.1M'
  },
  {
    id: '6',
    name: 'Maverick City Music',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    genre: 'Gospel Contemporáneo',
    followers: '1.9M'
  }
];

export const mockAlbums = [
  {
    id: 'album-1',
    title: 'Awake',
    artist: 'Hillsong Worship',
    artistId: '1',
    cover: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    year: 2023,
    tracks: 12,
    duration: '52:34'
  },
  {
    id: 'album-2',
    title: 'Lion',
    artist: 'Elevation Worship',
    artistId: '2',
    cover: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400',
    year: 2023,
    tracks: 10,
    duration: '45:21'
  },
  {
    id: 'album-3',
    title: 'Sana Nuestra Tierra',
    artist: 'Marcos Witt',
    artistId: '3',
    cover: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400',
    year: 2022,
    tracks: 14,
    duration: '58:12'
  },
  {
    id: 'album-4',
    title: 'Eterno Live',
    artist: 'Christine D\'Clario',
    artistId: '4',
    cover: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400',
    year: 2023,
    tracks: 11,
    duration: '49:45'
  },
  {
    id: 'album-5',
    title: 'Victory',
    artist: 'Bethel Music',
    artistId: '5',
    cover: 'https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?w=400',
    year: 2023,
    tracks: 13,
    duration: '54:30'
  },
  {
    id: 'album-6',
    title: 'Kingdom Book One',
    artist: 'Maverick City Music',
    artistId: '6',
    cover: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=400',
    year: 2022,
    tracks: 15,
    duration: '62:18'
  }
];

export const mockSongs = [
  {
    id: 'song-1',
    title: 'Reckless Love',
    artist: 'Hillsong Worship',
    artistId: '1',
    album: 'Awake',
    albumId: 'album-1',
    duration: '4:23',
    cover: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-2',
    title: 'What A Beautiful Name',
    artist: 'Hillsong Worship',
    artistId: '1',
    album: 'Awake',
    albumId: 'album-1',
    duration: '4:12',
    cover: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-3',
    title: 'O Come to the Altar',
    artist: 'Elevation Worship',
    artistId: '2',
    album: 'Lion',
    albumId: 'album-2',
    duration: '5:34',
    cover: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-4',
    title: 'LION',
    artist: 'Elevation Worship',
    artistId: '2',
    album: 'Lion',
    albumId: 'album-2',
    duration: '4:45',
    cover: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-5',
    title: 'Gracias',
    artist: 'Marcos Witt',
    artistId: '3',
    album: 'Sana Nuestra Tierra',
    albumId: 'album-3',
    duration: '4:56',
    cover: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-6',
    title: 'Sana Nuestra Tierra',
    artist: 'Marcos Witt',
    artistId: '3',
    album: 'Sana Nuestra Tierra',
    albumId: 'album-3',
    duration: '5:12',
    cover: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-7',
    title: 'Fuego',
    artist: 'Christine D\'Clario',
    artistId: '4',
    album: 'Eterno Live',
    albumId: 'album-4',
    duration: '4:34',
    cover: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-8',
    title: 'Como Dijiste',
    artist: 'Christine D\'Clario',
    artistId: '4',
    album: 'Eterno Live',
    albumId: 'album-4',
    duration: '5:23',
    cover: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-9',
    title: 'Goodness of God',
    artist: 'Bethel Music',
    artistId: '5',
    album: 'Victory',
    albumId: 'album-5',
    duration: '6:23',
    cover: 'https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-10',
    title: 'Raise A Hallelujah',
    artist: 'Bethel Music',
    artistId: '5',
    album: 'Victory',
    albumId: 'album-5',
    duration: '5:45',
    cover: 'https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-11',
    title: 'Jireh',
    artist: 'Maverick City Music',
    artistId: '6',
    album: 'Kingdom Book One',
    albumId: 'album-6',
    duration: '5:32',
    cover: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=400',
    audioUrl: '#'
  },
  {
    id: 'song-12',
    title: 'Promises',
    artist: 'Maverick City Music',
    artistId: '6',
    album: 'Kingdom Book One',
    albumId: 'album-6',
    duration: '4:52',
    cover: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=400',
    audioUrl: '#'
  }
];

export const mockPlaylists = [
  {
    id: 'playlist-1',
    name: 'Adoración Matutina',
    description: 'Comienza tu día alabando al Señor',
    cover: 'https://images.unsplash.com/photo-1518818419601-72c8673f5852?w=400',
    songs: ['song-1', 'song-2', 'song-9', 'song-10'],
    isPublic: true
  },
  {
    id: 'playlist-2',
    name: 'Worship en Español',
    description: 'Lo mejor de la música cristiana latina',
    cover: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=400',
    songs: ['song-5', 'song-6', 'song-7', 'song-8'],
    isPublic: true
  },
  {
    id: 'playlist-3',
    name: 'Momento de Oración',
    description: 'Música para tu tiempo íntimo con Dios',
    cover: 'https://images.unsplash.com/photo-1473177104440-ffee2f376098?w=400',
    songs: ['song-1', 'song-3', 'song-9', 'song-11'],
    isPublic: true
  },
  {
    id: 'playlist-4',
    name: 'Nuevos Lanzamientos',
    description: 'Las canciones más recientes de worship',
    cover: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400',
    songs: ['song-11', 'song-12', 'song-3', 'song-4'],
    isPublic: true
  }
];
